export default __webpack_public_path__ + "static/media/grafema_gim-tonico_05.aedac84a.jpg";